export default "__VITE_ASSET__7eW2a8iJ__"